import { ErrorHandler, Injectable, Injector, NgZone, inject } from '@angular/core';
import { RaxBFF } from '@raxapi/booker.planner.bff.api';
import { BffApiBusyService } from '@raxapp/booker-backend-apis/bff-api-busy.service';
import { CoreLoggerService } from '@raxapp/core/logger.service';
import { DebugModeService } from '@raxapp/debugging/debug-mode.service';
import { environment } from '../../environments/environment';
import { EnvType } from '../../environments/iEnvironment';
import { ShowErrorNotificationService } from './show-error-notifications/show-error-notification-service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    private injector = inject(Injector);

    handleError(error: unknown): void {
        console.error('GlobalErrorHandler', error);
        if (environment.envName === EnvType.acc || environment.envName === EnvType.prod || environment.envName === EnvType.hotfix) return;

        const debugModeService = this.injector.get(DebugModeService);
        const bffApiBusyService = this.injector.get(BffApiBusyService);
        const showErrorNotificationService = this.injector.get(ShowErrorNotificationService);
        const zone = this.injector.get(NgZone);
        const loggerService = this.injector.get(CoreLoggerService);

        if (!debugModeService.isActive()) return;

        const errorResult: RaxBFF.Result & Required<Pick<RaxBFF.Result, 'reason' | 'exceptionData'>> = {
            actionType: RaxBFF.ResultActionType.Undefined,
            isException: true,
            success: false,
            reason: 'Unknown error occured',
            exceptionData: {
                actionName: 'Global Error Handler',
                exceptionType: typeof error,
            },
        };

        if (error != undefined) {
            if (typeof error === 'string') {
                errorResult.reason = error;
                errorResult.exceptionData.message = errorResult.reason;
            } else if (typeof error === 'boolean') {
                errorResult.reason = 'Error bool: ' + error;
                errorResult.exceptionData.message = errorResult.reason;
            } else if (typeof error === 'number' || typeof error === 'bigint') {
                errorResult.reason = 'Error number: ' + error.toString();
                errorResult.exceptionData.message = errorResult.reason;
            } else if (error instanceof Error) {
                errorResult.reason = error.message;
                errorResult.exceptionData.exceptionType = error.name;
                errorResult.exceptionData.message = error.message;
                errorResult.exceptionData.stack = error.stack;
            } else if (error instanceof CloseEvent) {
                //errorResult.reason = "Live Updates: verbinding verbroken";
                return;
            } else if (typeof error === 'object') {
                errorResult.reason = 'Error object';
                errorResult.exceptionData.message = 'Error parsed to innerException using JSON.stringify(error)';
                errorResult.exceptionData.innerException = JSON.stringify(error);
            }
        }

        zone.run(() => {
            bffApiBusyService.clear();
            loggerService.logError(errorResult.reason, errorResult);
            showErrorNotificationService.show(errorResult, errorResult.reason, errorResult.reason);
        });
    }
}
